const Roles = {
  ADMIN: 'ADMIN',
  GUEST: 'GUEST',
  MANAGER: 'MANAGER',
}
export default Roles
  